// ═══════════════════════════════════════════════════════════════════
//  modules/chat/SujEtatSysteme.js
//  l'état du planificateur et des derniers passages
//
//  Sorti de SujPanel.js le 7 aout 2026. Le JSX est celui d'origine,
//  deplace au caractere pres ; les props sont calculees par analyse
//  de portee, pas devinees.
// ═══════════════════════════════════════════════════════════════════

import { Badge } from "../../composants/Badge";
import { THEME } from "../../socle/theme";
import { CHAT_PROJECT_NAME } from "./constantes";
import { sujDateLongue } from "./utils";

export function SujEtatSysteme({ carte, dernier, sys, tachesCfg }) {
  return (
    <>
      {/* État du système */}
      <div style={{ ...carte(), padding: "12px 16px", display: "flex", gap: 20, alignItems: "flex-start", flexWrap: "wrap" }}>
        <div>
          <div style={{ color: THEME.textMuted, fontSize: 9, fontWeight: 700, letterSpacing: 0.8, textTransform: "uppercase", marginBottom: 5 }}>État du système</div>
          <Badge text={sys.actif ? "ACTIF" : "EN PAUSE"} bg={sys.actif ? THEME.emeraldDim : THEME.surface} color={sys.actif ? THEME.emerald : THEME.textMuted} />
        </div>
        <div>
          <div style={{ color: THEME.textMuted, fontSize: 9, fontWeight: 700, letterSpacing: 0.8, textTransform: "uppercase", marginBottom: 5 }}>Dernière analyse</div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ color: THEME.text, fontSize: 12, fontWeight: 600 }}>{dernier ? sujDateLongue(dernier.window_start) : "jamais"}</span>
            {dernier && <Badge text={dernier.status === "success" ? "SUCCESS" : dernier.status === "empty" ? "VIDE" : "ERREUR"}
              bg={dernier.status === "success" ? THEME.emeraldDim : dernier.status === "empty" ? THEME.surface : THEME.redDim}
              color={dernier.status === "success" ? THEME.emerald : dernier.status === "empty" ? THEME.textMuted : THEME.red} />}
          </div>
        </div>
        <div>
          <div style={{ color: THEME.textMuted, fontSize: 9, fontWeight: 700, letterSpacing: 0.8, textTransform: "uppercase", marginBottom: 5 }}>Tâches automatiques</div>
          <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
            <Badge text={tachesCfg.actif ? `dès ${tachesCfg.seuil_occurrences} occ.` : "désactivées"}
              bg={tachesCfg.actif ? THEME.purpleDim : THEME.surface} color={tachesCfg.actif ? THEME.purple : THEME.textMuted} />
            <span style={{ color: THEME.textDim, fontSize: 11 }}>
              projet « {tachesCfg.projet_nom || CHAT_PROJECT_NAME} »{tachesCfg.projet_id ? ` (#${tachesCfg.projet_id})` : " — pas encore créé"}
            </span>
          </div>
        </div>
        {sys.fusion && sys.fusion.actif && (
          <div>
            <div style={{ color: THEME.textMuted, fontSize: 9, fontWeight: 700, letterSpacing: 0.8, textTransform: "uppercase", marginBottom: 5 }}>Fusion jeu ↔ Discord</div>
            <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
              <Badge text={`${sys.fusion.nb_sujets_partages || 0} sujet(s) partagé(s)`} bg={THEME.accentDim} color={THEME.accent} />
              <span style={{ color: THEME.textDim, fontSize: 11 }}>
                {(sys.fusion.labels || []).join(" · ")} — une seule ligne, une seule tâche
              </span>
            </div>
          </div>
        )}
        <div>
          <div style={{ color: THEME.textMuted, fontSize: 9, fontWeight: 700, letterSpacing: 0.8, textTransform: "uppercase", marginBottom: 5 }}>Conservation</div>
          <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
            <Badge text="AUCUNE PURGE" bg={THEME.emeraldDim} color={THEME.emerald} />
            <span style={{ color: THEME.textDim, fontSize: 11 }}>
              tout est conservé{sys.lot_size ? ` · lots de ${sys.lot_size} messages` : ""}
            </span>
          </div>
        </div>
      </div>
    </>
  );
}
